import {
    Gallery24,
    Gallery25,
    Gallery26,
    Gallery27,
    Gallery28,
    Gallery29,
    Gallery30,
}
from "assets/images/web-isn";

const listImages = [
    Gallery24,
    Gallery25,
    Gallery26,
    Gallery27,
    Gallery28,
    Gallery29,
    Gallery29,
    Gallery30,
    Gallery26,
    Gallery27,
    Gallery28,
    Gallery26,
    Gallery29,
    Gallery29,
    Gallery30,
]
export default listImages;